<template>
    <div class="messageBox">
        <avue-crud :data="data" :option="option" :page.sync="page" @current-change="currentChange">

        </avue-crud>
    </div>
</template>

<script>
    import { leaveMessageList } from '../../../api/insure';

    export default {
        name: 'leaveMessage',
        data() {
            return {
                page: {
                    currentPage: 1,
                    total: 20,  //总数
                    pageSize: 10
                },
                data: [],
                option: {
                    stripe: true,
                    addBtn: false,  //新增按钮
                    align: 'center',  //文本居中
                    menuAlign: 'center', //操作栏居中
                    columnBtn: false,  //列动态显隐按钮
                    refreshBtn: false,  //刷新按钮
                    editBtn: false,  //编辑按钮
                    delBtn: false,  //删除按钮
                    menu: false,   //操作栏是否显示
                    column: [
                        {
                            label: 'ID',
                            prop: 'id'
                        }, {
                            label: '留言人',
                            prop: 'liuyan_ren'
                        }, {
                            label: '留言内容',
                            prop: 'content'
                        }, {
                            label: '留言时间',
                            prop: 'create_time'
                        }
                    ]
                }
            };
        },
        methods: {
            //分页
            currentChange(num) {
                leaveMessageList(this.$route.query.id, 10, num).then(res => {
                    if (res.code == 200) {
                        this.data = res.data.list;
                        this.page.total = res.data.count;
                    }
                });
            }
        },
        created() {
            leaveMessageList(this.$route.query.id, 10, 1).then(res => {
                if (res.code == 200) {
                    this.data = res.data.list;
                    this.page.total = res.data.count;
                    this.page.currentPage = 1;
                }
            });
        }
    };
</script>

<style scoped>
    .messageBox {
        padding: 30px;
        background-color: #ffffff;
        border-radius: 5px;
    }
</style>
